var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdfIcn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pdf_icn",
    transform: "translate(-851 -193)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_48183",
    "data-name": "Path 48183",
    transform: "translate(855 193)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18 24.25 L 2 24.25 C 1.310750007629395 24.25 0.75 23.68925094604492 0.75 23 L 0.75 2 C 0.75 1.310750007629395 1.310750007629395 0.75 2 0.75 L 12.92679500579834 0.75 L 19.25 6.344202995300293 L 19.25 23 C 19.25 23.68925094604492 18.68925094604492 24.25 18 24.25 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2 1.5 C 1.724300384521484 1.5 1.5 1.724300384521484 1.5 2 L 1.5 23 C 1.5 23.27569961547852 1.724300384521484 23.5 2 23.5 L 18 23.5 C 18.27569961547852 23.5 18.5 23.27569961547852 18.5 23 L 18.5 6.682056427001953 L 12.64265060424805 1.5 L 2 1.5 M 2 0 L 13.21093940734863 0 L 20 6.006349563598633 L 20 23 C 20 24.10457038879395 19.10457038879395 25 18 25 L 2 25 C 0.8954296112060547 25 0 24.10457038879395 0 23 L 0 2 C 0 0.8954296112060547 0.8954296112060547 0 2 0 Z",
    stroke: "none",
    fill: "#9facc2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10859",
    "data-name": "Rectangle 10859",
    transform: "translate(852 202)",
    fill: "red",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 10,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: -0.5,
    width: 21,
    height: 11,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PDF",
    transform: "translate(854 210)",
    fill: "#fff",
    fontSize: 9,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PDF")), /*#__PURE__*/React.createElement("g", {
    id: "Path_48182",
    "data-name": "Path 48182",
    transform: "translate(867.68 192.36)",
    fill: "#9facc2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.44807767868042 7.099613189697266 L 2.188555955886841 7.099613189697266 C 1.257475852966309 7.099613189697266 0.4999959170818329 6.342133045196533 0.4999959170818329 5.41105318069458 L 0.4999959170818329 1.710393786430359 C 1.165418028831482 2.270837783813477 2.154388904571533 3.111803770065308 3.153595924377441 3.990693092346191 C 5.094727039337158 5.698089122772217 6.013398170471191 6.615234375 6.44807767868042 7.099613189697266 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5.264666080474854 6.599613189697266 C 4.71883487701416 6.068692207336426 3.910158157348633 5.31967306137085 2.71246600151062 4.268692970275879 C 2.110794305801392 3.740721702575684 1.516846537590027 3.229665517807007 0.9999958872795105 2.789250135421753 L 0.9999958872795105 5.41105318069458 C 0.9999958872795105 6.066422939300537 1.533185958862305 6.599613189697266 2.188555955886841 6.599613189697266 L 5.264666080474854 6.599613189697266 M 7.200985908508301 7.599613189697266 L 2.188555955886841 7.599613189697266 C 0.9798558950424194 7.599613189697266 -4.094696123502217e-06 6.619752883911133 -4.094696123502217e-06 5.41105318069458 L -4.094696123502217e-06 0.6401330232620239 C -4.094696123502217e-06 0.6401330232620239 8.409695625305176 7.599613189697266 7.200985908508301 7.599613189697266 Z",
    stroke: "none",
    fill: "#9facc2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcn);
export default __webpack_public_path__ + "static/media/pdf_icn.4d0e55681c3d39236e254aaf20f897c4.svg";
export { ForwardRef as ReactComponent };